"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.readMembershipPaymentChoice = readMembershipPaymentChoice;
exports.validateMembershipPaymentChoice = validateMembershipPaymentChoice;
exports.initMembershipPaymentChoice = initMembershipPaymentChoice;
var error_helper_const_1 = require("@src/const/error-handling/error-helper.const");
var input_output_helper_const_1 = require("@src/const/input-output-helper.const");
var input_mapping_const_1 = require("@src/const/input.mapping.const");
var cash_dom_1 = __importDefault(require("cash-dom"));
function readMembershipPaymentChoice($container) {
    var _a;
    var field = (0, input_output_helper_const_1._GetFieldDomObj)(input_mapping_const_1._PaymentChoice, $container);
    // Read the select itself, including its default option, even before the form is visible.
    var value = field.length ? (_a = field.val()) !== null && _a !== void 0 ? _a : '' : 'DIRECT_DEBIT';
    return {
        paymentChoice: (value || 'DIRECT_DEBIT'),
        valid: input_mapping_const_1._PaymentChoice.regex.test(value),
        requiresBankAccount: !field.length || value === 'DIRECT_DEBIT',
    };
}
function validateMembershipPaymentChoice($container, options) {
    var result = readMembershipPaymentChoice($container);
    var field = (0, input_output_helper_const_1._GetFieldDomObj)(input_mapping_const_1._PaymentChoice, $container);
    (0, error_helper_const_1._RemoveStatusFromDomObject)(field);
    if (!result.valid && options.showErrors)
        (0, error_helper_const_1._AddErrorToDomObject)(field);
    return result;
}
function initMembershipPaymentChoice($container) {
    var choiceField = (0, input_output_helper_const_1._GetFieldDomObj)(input_mapping_const_1._PaymentChoice, $container);
    if (!choiceField.length)
        return;
    var bankFields = $container.find("\n    [data-get=\"".concat(input_mapping_const_1._BankAccountMapping.iban.uid, "\"], [data-set=\"").concat(input_mapping_const_1._BankAccountMapping.iban.uid, "\"],\n    [data-get=\"").concat(input_mapping_const_1._BankAccountMapping.accountHolder.uid, "\"], [data-set=\"").concat(input_mapping_const_1._BankAccountMapping.accountHolder.uid, "\"],\n    [data-get=\"").concat(input_mapping_const_1._BankAccountMapping.consent.uid, "\"], [data-set=\"").concat(input_mapping_const_1._BankAccountMapping.consent.uid, "\"],\n    ").concat(input_mapping_const_1._BankAccountMapping.iban.legacy.id, ",\n    ").concat(input_mapping_const_1._BankAccountMapping.accountHolder.legacy.id, ",\n    ").concat(input_mapping_const_1._BankAccountMapping.consent.legacy.id, "\n  "));
    var consentParent = $container.find(input_mapping_const_1._BankAccountMapping.consent.legacy.id).parent();
    var inputs = bankFields.filter('input').add(bankFields.find('input'));
    var update = function (source) {
        var _a = readMembershipPaymentChoice($container), showBankFields = _a.requiresBankAccount, paymentChoice = _a.paymentChoice;
        bankFields.toggle(showBankFields);
        consentParent.toggle(showBankFields);
        inputs.prop('disabled', !showBankFields);
        console.log('[membership-completion] IBAN visibility', {
            source: source,
            paymentChoice: paymentChoice,
            visibility: showBankFields ? 'visible' : 'hidden',
        });
        if (!showBankFields) {
            bankFields.add(inputs).each(function (_index, element) { return (0, error_helper_const_1._RemoveStatusFromDomObject)((0, cash_dom_1.default)(element)); });
        }
    };
    choiceField.off('change.membershipPaymentChoice').on('change.membershipPaymentChoice', function () { return update('change'); });
    update('load');
}
